import useAxiosService from './useAxiosService'
import { IResponse } from 'interfaces/services'
import { INotification } from 'pages/notifications/interfaces'

const useNotificationService = () => {
  const { post, get } = useAxiosService()

  const getNotifications = async (query: {
    limit: number
    offset: number
    query?: { unread_only?: boolean; types?: string[] } | { types?: string[] }
  }) => {
    const response: any = await post(`/clinic-notification-log`, query)
    return response as IResponse<{ notifications: Array<INotification> }>
  }

  const getNotificationsDetail = async (id?: number) => {
    const response: any = await get(`/clinic-notification-log/${id}`)
    return response as IResponse<{ notifications: Array<INotification> }>
  }

  const getCountUnread = async (query: { query?: { types?: string[] } }) => {
    const response: any = await post(
      `/clinic-notification-log/count-unread`,
      query
    )
    return response as IResponse<{ unread_count: number }>
  }
  return { getNotifications, getCountUnread, getNotificationsDetail }
}

export default useNotificationService
